<div class="version-info">{{ environment }} - {{ currentVersion }}</div>
@if (hasNewVersion) {
  <button color="warn" data-testid="version-check-button" (click)="forceUpdate()">
    <mat-icon>system_update</mat-icon>
    <span>Update</span>
  </button>
}
